export const hasRole = (userRoles:any, role:any) => {
  return userRoles?.some((userRole:any) => userRole.id === role);
};